export enum ARTICLES {
    /**
     * @value Article analytics
     * @description The label of the button to access an article analytics
     */
    ARTICLE_ANALYTICS = 'ARTICLES.ARTICLE_ANALYTICS',
    /**
     * @value Select an article
     */
    ARTICLE_PICKER_TITLE = 'ARTICLE.ARTICLE_PICKER_TITLE',
    /**
     * @value Write your text here.
     * @description Placeholder for text article text content
     */
    CONTENT_PLACEHOLDER = 'FRONT.ARTICLES.DIALOG.CONTENT_PLACEHOLDER',
    /**
     * @value Article deleted
     */
    DELETED = 'ARTICLES.DELETED',
    /**
     * @value Delete article
     * @description Label for a button to delete an article
     */
    DELETE_ARTICLE = 'FRONT.ARTICLES.DIALOG.DELETE_ARTICLE',
    /**
     * @value Keep it
     * @description Button to cancel the deletion of an article
     */
    DELETE_CONFIRM_DIALOG_CANCEL = 'FRONT.ARTICLES.DELETE.CONFIRM_DIALOG.CANCEL',
    /**
     * @value The article will be deleted permanently. This action can't be reverted
     */
    DELETE_CONFIRM_DIALOG_DESCRIPTION = 'FRONT.ARTICLES.DELETE.CONFIRM_DIALOG.DESCRIPTION',
    /**
     * @value Delete article
     * @description Button to confirm the deletion of an article
     */
    DELETE_CONFIRM_DIALOG_OK = 'FRONT.ARTICLES.DELETE.CONFIRM_DIALOG.OK',
    /**
     * @value Delete article
     */
    DELETE_CONFIRM_DIALOG_TITLE = 'FRONT.ARTICLES.DELETE.CONFIRM_DIALOG.TITLE',
    /**
     * @value Article successfully deleted
     */
    DELETE_SUCCESS_NOTIFICATION = 'FRONT.ARTICLES.DELETE.SUCCESS_NOTIFICATION',
    /**
     * @value Title and text are mandatory.
     */
    DIALOG_REQUIRED_FIELD = 'ARTICLES.DIALOG_REQUIRED_FIELDS',
    /**
     * @value Edit article
     * @description Title of the article dialog.
     */
    EDIT_ARTICLE = 'FRONT.ARTICLES.DIALOG.EDIT_ARTICLE',
    /**
     * @value New article
     * @description Title of the article dialog.
     */
    NEW_ARTICLE = 'FRONT.ARTICLES.DIALOG.NEW_ARTICLE',
    /**
     * @value Published an article
     * @description Text describing that an article has been published.
     */
    PUBLISHED_AN_ARTICLE = 'STREAMS.PUBLISHED_AN_ARTICLE',
    /**
     * @value Published an article in %CONTAINER%
     * @description Text describing that an article has been published in the given container.
     */
    PUBLISHED_AN_ARTICLE_IN_CONTAINER = 'STREAMS.PUBLISHED_AN_ARTICLE_IN_CONTAINER',
    /**
     * @value Publish changes
     * @description Label of the button used to update the current article with the latest modifications
     */
    PUBLISH_CHANGES = 'FRONT.ARTICLES.DIALOG.PUBLISH_CHANGES',
    /**
     * @value {"one":"%COUNT% article selected","other":"%COUNT% articles selected"}
     */
    SELECTED_ARTICLES_COUNT = 'ARTICLES.SELECTED_ARTICLES_COUNT',
    /**
     * @value Select articles
     */
    SELECT_ARTICLES = 'ARTICLES.SELECT_ARTICLES',
    /**
     * @value Add a title
     * @description PLaceholder for article title
     */
    TITLE_PLACEHOLDER = 'FRONT.ARTICLES.DIALOG.TITLE_PLACEHOLDER',
}
